import { createContext } from 'react';

/**
 * EAA-1844: the two theme states the runtime knows about — matches tokens.css's
 * `:root` (light) / `:root[data-theme="dark"]` (dark) override block.
 */
export type PortalTheme = 'light' | 'dark';

export interface ThemeContextValue {
    theme: PortalTheme;
    setTheme: (theme: PortalTheme) => void;
    toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
